import * as React from 'react';

const SvgActionAiText = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#88827E", d: "m19.764 17.202 2.202 1.281-2.202 1.28-1.28 2.203-1.282-2.202L15 18.484l2.202-1.282L18.483 15l1.28 2.202ZM11.75 17H3v-2h8.75v2ZM18 13H3v-2h15v2Zm-2-4H3V7h13v2Zm4-4H3V3h17v2Z" })
);

export { SvgActionAiText as default };
//# sourceMappingURL=ActionAiText.es.js.map
